import { useEffect, useState } from 'react';

import { HandleLocalState } from 'types';

interface ReturnType {
  isShow: boolean;
  setIsShow: HandleLocalState<boolean>;
}

function useWidth(initialValue: boolean, MAX_SCREEN_WIDTH: number = 800): ReturnType {
  const [isShow, setIsShow] = useState(initialValue);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize(): void {
      setWindowWidth(window.innerWidth);
    }

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (windowWidth && windowWidth <= MAX_SCREEN_WIDTH) {
      if (setIsShow) {
        setIsShow(false);
      }
    }
    if (windowWidth > MAX_SCREEN_WIDTH) {
      if (setIsShow) {
        setIsShow(true);
      }
    }
  }, [windowWidth]);

  return { isShow, setIsShow };
}
export { useWidth };
